import { useMutation } from '@tanstack/react-query';

import { $apiV2, errorHandler } from 'modules/global';

export const useSendLead = () =>
  useMutation({
    mutationFn: async (data: { teacher_course_id?: number; name?: string; phone?: string }) => {
      const res = await $apiV2.post('/lead/course-send', data);

      return res.data;
    },
    onError: errorHandler()
  });
